// this is a temporary file to migrate print package atoms to typescript
// once we have all atoms migrated, we can remove this file and place atoms in printPackageAtoms.ts (or reorganize them)

import { atom } from 'recoil'
import type {
  GetOrderProduct,
  GetM3OrderProduct,
  EditorOrderPageDetailsNormalized,
} from '@messenger/types'

type OrderProductId =
  | GetOrderProduct['id']
  | GetM3OrderProduct['id']
  | EditorOrderPageDetailsNormalized['product']['id']
  | EditorOrderPageDetailsNormalized['order_product']['id']

/**
 * Product tab atom stores the currently active order product ID (UUID string) or null.
 *
 * This stores the **OrderProduct.id** (the UUID of the order product record from the database),
 * NOT the global **Product.id**.
 */
export const productTabAtom = atom<OrderProductId | null>({
  key: 'productTab',
  default: null,
})
